import { list } from './List/List.i18n.en'

export const notifications = {
  list,
}
